<template lang="pug">

div

    .ui.secondary.menu
        //- Der Toggle-Button für die Haupt-Sidebar
        //- a.item(@click="$emit('toggle')" title="Menü umschalten")
        //-     i.bars.icon

        router-link.item(:to="productsIndex" exact) Übersicht Produkte
        router-link.item(:to="productsView" v-if="isProductViewVisible") Produkt anzeigen
        router-link.item(:to="productsCreate") Produkt anlegen
        router-link.item(:to="campaignsIndex" exact) Übersicht Kampagnen
        router-link.item(:to="campaignsUpdate" v-if="$route.name === 'campaigns/update'") Kampagne bearbeiten
        router-link.item(:to="campaignsCreate") Kampagne anlegen
        router-link.item(:to="productsTemplates") Übersicht Vorlagen

        //- Unten platzierte Controls (Theme & User)
        //- .right.menu
        //-     .item
        //-         user-menu-dropdown

    .ui.divider

</template>

<script>
    import UserMenuDropdown from './../app/UserMenuDropdown.vue'
    import ThemeControls from './../app/ThemeControls.vue'

    export default {

        components: { UserMenuDropdown, ThemeControls },

        props: {
            isExpanded: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            campaignsCreate() {
                return { name: 'campaigns/create' }
            },

            campaignsIndex() {
                return { name: 'campaigns' }
            },

            campaignsUpdate() {
                return {
                    name: 'campaigns/update',
                    params: {
                        id: this.$route.params.id
                    }
                }
            },

            isProductViewVisible() {
                return this.$route.matched[0].name === 'products/view'
            },

            productsCreate() {
                return { name: 'products/create' }
            },

            productsTemplates() {
                return { name: 'products/templates' }
            },

            productsIndex() {
                return { name: 'products' }
            },

            productsView() {
                return {
                    name: 'products/view',
                    params: {
                        id: this.$route.params.id,
                        variantId: this.$route.params.variantId
                    }
                }
            }

        }

    }

</script>
